import { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { buyNowItem, restoreBuyNowCartSnapshot } from "../State/Cart/Action";
import HomePage from "../Pages/HomePage/HomePage";
import Footer from "../Components/Footer/Footer";
import ProductDetails from "../Components/ProductDetails/ProductDetails";
import Cart from "../Components/Cart/Cart";
import PaymentSuccess from "../Components/Payment/PaymentSuccess";
import Order from "../Components/Order/Order";
import OrderDetails from "../Components/Order/OrderDetails";
import Product from "../Components/Product/Product";
import DesignerProducts from "../Components/DesignerProduct/DesignerProducts";
import SaleAndOffer from "../Pages/Sale&Offer/SaleAndOffer";
import DesignerAndOffers from "../Pages/DesignerAndOffers/DesignerAndOffers";
import FestivalOffers from "../Pages/FestivalOffer/FestivalOffers";
import CollectionsCategory from "../Pages/ProductsCollection/CollectionsCategory";
import NewArrivals from "../Pages/NewArrivals/NewArrivals";
import Trending from "../Pages/Trending/Trending";
import Reviews from "../Pages/Reviews/Reviews";
import LoginPage from "../Auth/LoginPage";
import SearchPage from "../Pages/SearchPage/SearchPage";
import Loader from "../Components/Loader/Loader";
import DesignerAndVendorAndOffers from "../Pages/DesignerAndVendorAndOffers/DesignerAndVendorAndOffers";
import DesignerAndVendor from "../Pages/DesignerAndVendor/DesignerAndVendor";
import Navigation from "../Components/Navigation/Navigation";
import TermAndCondition from "../Pages/Policy/TermAndCondition";
import ShippingPolicy from "../Pages/Policy/ShippingPolicy";
import PolicySideLinks from "../Pages/Policy/PolicySideLinks";
import ReturnPolicy from "../Pages/Policy/ReturnPolicy";
import PrivacyAndPolicy from "../Pages/Policy/PrivacyAndPolicy";
import ConfirmSubscription from "../Pages/Subcription/ConfirmSubscription";
import ManageSubscription from "../Pages/Subcription/ManageSubscription";
import UnsubscribePage from "../Pages/Subcription/UnSubscription";
import FAQs from "../Pages/Policy/Faqs";
import ContactUs from "../Pages/Policy/ContactUs";
import AboutUs from "../Pages/Policy/AboutUs";
import DesignerAndDiscount from "../Pages/DesignerAndDiscount/DesignerAndDiscount";
import DesignerDiscountBanners from "../Pages/DesignerAndDiscount/DesignerDiscountBanners";
import ProtectedRoute from "../../config/ProtectedRoute";
import { CurrencyProvider } from "../../config/CurrencyContext";
import CheckoutPage from "../Components/Checkout/CheckoutPage";
import PersonalDetail from "../Pages/AccountPages/PersonalDetail";
import OrderHistory from "../Pages/AccountPages/OrderHistory";
import Address from "../Pages/AccountPages/Address";
import Credits from "../Pages/AccountPages/Credits";
import Setting from "../Pages/AccountPages/Setting";
import Wishlist from './../Pages/AccountPages/Wishlist';
import ScrollToTopButton from "../../Common/ScrollToTopButton";
import SideAppDownloadBanner from "../../Common/SideAppDownloadBanner";

const CustomerRouters = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const hideLayoutRoutes = ["/login", "/admin/", "/vendor/", "/employee/", "/admin", "/vendor", "/employee", "/employee/admin/", "/employee/vendor/"]; // Add more if needed

  const shouldHideLayout = hideLayoutRoutes.includes(location.pathname);

  const jwt = localStorage.getItem("jwt");
  const role = localStorage.getItem('role');
  const authJwt = useSelector((store) => store.auth?.jwt);

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/cart/checkout") || path.startsWith("/payment")) {
      return;
    }
    dispatch(restoreBuyNowCartSnapshot());
  }, [dispatch, location.pathname]);

  useEffect(() => {
    const token = localStorage.getItem("jwt");
    const userRole = localStorage.getItem("role");
    if (!token || userRole !== "CUSTOMER") {
      return;
    }
    const pending = localStorage.getItem("pendingBuyNowSelection");
    if (!pending) {
      return;
    }
    try {
      const parsed = JSON.parse(pending);
      if (parsed?.productId && parsed?.variantId && parsed?.data) {
        localStorage.removeItem("pendingBuyNowSelection");
        dispatch(buyNowItem(parsed.productId, parsed.variantId, parsed.data, navigate));
      }
    } catch (error) {
      localStorage.removeItem("pendingBuyNowSelection");
    }
  }, [authJwt, dispatch, navigate]);

  return <CurrencyProvider> {/* ✅ Wrap entire routes in provider */}
    <div>
      {!shouldHideLayout && <Navigation />}

      <div className={!shouldHideLayout ? "pt-[92px] md:pt-[96px] bg-white" : ""}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin/*" element={<Loader />} />
          <Route path="/vendor/*" element={<Loader />} />
          <Route path="/employee/*" element={<Loader />} />
        </Routes>

        {!shouldHideLayout &&
          <>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/product/:productId" element={<ProductDetails />} />

              <Route
                path="/cart"
                element={
                  <ProtectedRoute jwt={jwt} role={role} >
                    <Cart />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/account"
                element={
                  <ProtectedRoute jwt={jwt} role={role} >
                    <PersonalDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/account/order-history"
                element={
                  <ProtectedRoute jwt={jwt} role={role} >
                    <OrderHistory />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/account/addresses"
                element={
                  <ProtectedRoute jwt={jwt} role={role} >
                    <Address />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/account/credits"
                element={
                  <ProtectedRoute jwt={jwt} role={role} >
                    <Credits />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/account/settings"
                element={
                  <ProtectedRoute jwt={jwt} role={role} >
                    <Setting />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/account/wishlist"
                element={
                  <ProtectedRoute jwt={jwt} role={role} >
                    <Wishlist />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/cart/checkout"
                element={
                  <ProtectedRoute jwt={jwt} role={role} >
                    <CheckoutPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/payment/:orderId"
                element={
                  <ProtectedRoute jwt={jwt} role={role} >
                    <PaymentSuccess />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/account/order"
                element={
                  <ProtectedRoute jwt={jwt} role={role} >
                    <Order />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/account/order/:orderId"
                element={
                  <ProtectedRoute jwt={jwt} role={role} >
                    <OrderDetails />
                  </ProtectedRoute>
                }
              />


              <Route path="/products/search" element={<SearchPage />} />

              <Route path="/:levelOne" element={<CollectionsCategory />} />
              <Route path="/category/:levelOne/banner/vendors/products" element={<CollectionsCategory />} />
              <Route path="/category/:levelOne/banner/products" element={<CollectionsCategory />} />
              <Route path="/:levelOne/:levelTwo/:levelThree" element={<Product />} />
              <Route path="/collections/:vendor/brand/:brand" element={<DesignerAndVendor />} />
              <Route path="/collections/brand/:designer" element={<DesignerProducts />} />
              <Route path="/collections/vendor/:vendor" element={<DesignerProducts />} />
              <Route path="/collections/brand/:designer/sales/:offers" element={<DesignerAndOffers />} />
              <Route path="/collections/vendor/:vendor/sales/:offers" element={<DesignerAndOffers />} />
              <Route path="/collections/:vendor/brand/:brand/sales/:offers" element={<DesignerAndVendorAndOffers />} />
              <Route path="/sales/:offers" element={<SaleAndOffer />} />
              <Route path="/festival-offers/:specialOffer" element={<FestivalOffers />} />
              <Route path="/collections/vendor/:vendor/discount/:discount" element={<DesignerAndDiscount />} />
              <Route path="/collections/designer-discount-banners" element={<DesignerDiscountBanners />} />

              <Route path="/new-arrivals" element={<NewArrivals />} />
              <Route path="/trending" element={<Trending />} />
              <Route path="/reviews" element={<Reviews />} />

              <Route path="/terms-condition" element={<PolicySideLinks><TermAndCondition /></PolicySideLinks>} />
              <Route path="/shipping-policy" element={<PolicySideLinks><ShippingPolicy /></PolicySideLinks>} />
              <Route path="/return-policy" element={<PolicySideLinks><ReturnPolicy /></PolicySideLinks>} />
              <Route path="/privacy-policy" element={<PolicySideLinks><PrivacyAndPolicy /></PolicySideLinks>} />
              <Route path="/faqs" element={<PolicySideLinks><FAQs /></PolicySideLinks>} />
              <Route path="/contactUs" element={<PolicySideLinks><ContactUs /></PolicySideLinks>} />
              <Route path="/aboutUs" element={<PolicySideLinks><AboutUs /></PolicySideLinks>} />
              <Route path="/confirm-subscription" element={<ConfirmSubscription />} />
              <Route path="/manage-subscription" element={<ManageSubscription />} />
              <Route path="/unSubscription" element={<UnsubscribePage />} />

            </Routes>
            <ScrollToTopButton />
            <SideAppDownloadBanner />
          </>
        }
      </div>
      {!shouldHideLayout && <Footer />}
    </div>
  </CurrencyProvider>;
};

export default CustomerRouters;
